module.exports = __webpack_public_path__ + "static/img/02.761db14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/01/02.jpg
// module id = drbk
// module chunks = 0